import FlexListSummary from "@/components/listSummary/FlexListSummary";
import { ComputePoolsSummary } from "../types";
import { useAppState } from "@/modules/app/useAppContext";
import { formatNumber } from "@uicore";

const SummaryCards = ({ summary }: { summary: ComputePoolsSummary | undefined }) => {
  const { currency } = useAppState();
  const s = summary;
  const list = s
    ? [
        { label: "Total Spend", value: formatNumber(s.total_spend, { currency }) },
        { label: "Average Daily Spend", value: formatNumber(s.average_daily_spend, { currency }) },
        { label: "Active Pools", value: String(s.active_pools) },
        { label: "Exclusive Pools", value: String(s.exclusive_pools) },
      ]
    : [];
  return <FlexListSummary summary={list} />;
};

export default SummaryCards;
